import { Component, OnInit, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { WpApiService } from '../../services/wp-api/wp-api.service';

@Component({
  selector: 'ags-navigation-menu',
  templateUrl: './navigation-menu.component.html',
  styleUrls: ['./navigation-menu.component.scss']
})
export class NavigationMenuComponent implements OnInit {
  // not in actu section // @HostBinding('class') themeFlag = 'wp-theme exported';
  public items: any[];

  constructor(private router: Router, private wpApiService: WpApiService) {}

  ngOnInit() {
    this.wpApiService.getNavMenu().subscribe(nav => (this.items = nav));
  }

  public onSelect({ item }): void {
    if (item.path && item.path.length > 0) {
      if ((item.path as string).indexOf('/') === 0) {
        this.router.navigate([item.path]);
      } else {
        const fullUrl = (item.path as string).indexOf('http') === 0 ? item.path : `http://${item.path}`;
        window.open(fullUrl);
      }
    }
  }
}
